<template>
  <v-app>
    <v-toolbar color="primary" app>
      <router-link to="/"><img src="/static/images/white-logo.png" /></router-link>
      <v-toolbar-title class="white--text">Travelers Haven</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu bottom left v-if="account.status.loggedIn">
        <v-btn slot="activator"
               dark
               icon
               >
               <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
            <v-list-tile v-for="(item, index) in items"
                         :key="index"
                         @click="item.action"
                         >
                         <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
      </v-menu>
    </v-toolbar>
    <v-content>
      <v-alert v-model="alert" v-if="alert.message" :type="alert.type">
        {{alert.message}}
      </v-alert>
      <router-view></router-view>
    </v-content>
    <v-footer app></v-footer>
  </v-app>
</template>
<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'app',
  data() {
    return {
      items: [{
        title: 'Logout',
        action: this.logout
      }]
    };
  },
  computed: {
    ...mapState({
      alert: state => state.alert,
      account: state => state.account
    })
  },
  methods: {
    ...mapActions({
      clearAlert: 'alert/clear',
      logout: 'account/logout'
    })
  },
  watch: {
    $route (to, from) {
      // clear alert on location change
      this.clearAlert();
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Lato:300,400,700");
@import "./style/variables";

#app {
  color: $font;
  font-family: "Lato", sans-serif;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue